import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimeActualDateState = atom({
  key: "myTimeActualDateState",
  default: new Date(),
  effects_UNSTABLE: [ocPersistAtom],
});
